// Used to hole the message and other common properties of the message

import React from 'react';
import { participant_types } from '../../../../constants/WebchatConstants';
import { Space, Typography } from 'antd';
import moment from 'moment/moment';
import MessageStatus from './MessageStatus';
import MessageAvatar from './MessageUser';
const { Text } = Typography;
const MessageWrapper = ({
  children,
  participantType: type,
  timestamp,
  status,
  item: message,
}) => {
  const participantType = participant_types[type];
  const isEndUser = participantType === 'END_USER';
  // const isAgent = participantType === 'AGENT';
  // const isSystemUser = participantType === 'SYSTEM_USER';
  // console.log({ isSystemUser, isAgent, isEndUser });

  // #d8fbd2

  return (
    <div className="flex align-center gap-3">
      <div
        className={`flex flex-col order-3 max-w-[300px] ${
          isEndUser ? 'mr-auto  pr-4' : 'ml-auto pl-4'
        }`}
      >
        <div
          className={`flex flex-col gap-5 bg-[#9ad48f] px-4 py-2 max-w-[300px] rounded-2xl ${
            isEndUser
              ? 'rounded-bl-none rounded-tl-xl'
              : 'rounded-br-none rounded-tr-xl'
          }`}
        >
          {children}
        </div>

        <Space
          align="center"
          size={4}
          className={`flex items-center justify-center ${
            isEndUser ? 'mr-auto ' : 'ml-auto'
          }`}
        >
          <Text className="text-xs text-gray-500">
            {moment(timestamp).format('hh:mm A z')}
          </Text>
          <MessageStatus
            status={status}
            timestamp={timestamp}
            participantType={participantType}
          />
        </Space>
      </div>
      {isEndUser ? (
        <MessageAvatar
          className="order-2"
          avatarType={participantType}
          message={message}
        />
      ) : (
        <MessageAvatar
          className="order-4"
          avatarType={participantType}
          message={message}
        />
      )}
    </div>
  );
};

export default MessageWrapper;
